import {
  ChangeDetectionStrategy,
  Component,
  ElementRef,
  EventEmitter,
  HostListener,
  Input,
  Output,
} from '@angular/core';
import { ToolName } from '@textbook-drawer';
import { BehaviorSubject } from 'rxjs';

@Component({
  selector: 'txtb-drawer-eraser-tool',
  templateUrl: './drawer-eraser-tool.component.html',
  styleUrls: ['./drawer-eraser-tool.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class DrawerEraserToolComponent {
  @Input() activeColor: string | null | undefined;
  @Input() activeFill: string | null | undefined;
  @Input() clearCanvasColor = '';
  @Input() disabledColor: string | null | undefined;

  @Input() isCanvasDirty: boolean | null = false;
  @Input() isOffline: boolean | null = false;
  @Input() isZoomed = false;
  @Input() tool$!: BehaviorSubject<ToolName | undefined>;
  @Output() clearAll = new EventEmitter<void>();
  @Output() toggleEraser = new EventEmitter<void>();
  tooltip = false;

  constructor(private elementRef: ElementRef) {}

  @HostListener('document:click', ['$event'])
  onOutsideClick(event: MouseEvent): void {
    if (this.tooltip && !this.elementRef.nativeElement.contains(event.target)) {
      this.tooltip = false;
    }
  }

  sendToolToggle(): void {
    this.tooltip = !this.tooltip;
    this.toggleEraser.emit();
  }

  clear(): void {
    this.tooltip = false;
    this.clearAll.emit();
  }

  toggleTooltip(): void {
    if (this.tool$.getValue() === ToolName.Eraser) {
      this.toggleEraser.emit();
      return;
    }

    this.tooltip = !this.tooltip;
  }
}
